import { render, staticRenderFns } from "./CheckFirmBx.vue?vue&type=template&id=a8445094&"
import script from "./CheckFirmBx.vue?vue&type=script&lang=js&"
export * from "./CheckFirmBx.vue?vue&type=script&lang=js&"
import style0 from "./CheckFirmBx.vue?vue&type=style&index=0&id=a8445094&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports